/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import ListChatActivitiesPaginationEmbedQuery from "./ListChatActivitiesPaginationEmbedQuery.graphql";
import { FragmentRefs } from "relay-runtime";
export type ListChatActivitiesPagination_EmbedQuery = {
    readonly chatActivityConnection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly _id: string;
                readonly patient: {
                    readonly _id: string;
                } | null;
                readonly readByUser: boolean | null;
                readonly oid_patient: string | null;
                readonly oid_assignee: string | null;
                readonly oid_groupAssignee: string | null;
                readonly " $fragmentRefs": FragmentRefs<"ListItemChatActivity_EmbedChatActivity">;
            };
        }>;
    } | null;
    readonly " $refType": "ListChatActivitiesPagination_EmbedQuery";
};
export type ListChatActivitiesPagination_EmbedQuery$data = ListChatActivitiesPagination_EmbedQuery;
export type ListChatActivitiesPagination_EmbedQuery$key = {
    readonly " $data"?: ListChatActivitiesPagination_EmbedQuery$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListChatActivitiesPagination_EmbedQuery">;
};



const node: ReaderFragment = (function(){
var v0 = [
  "chatActivityConnection"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 15,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeAssignee"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ListChatActivitiesPaginationEmbedQuery
    }
  },
  "name": "ListChatActivitiesPagination_EmbedQuery",
  "selections": [
    {
      "alias": "chatActivityConnection",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "concreteType": "ChatActivityConnection",
      "kind": "LinkedField",
      "name": "__ListChatActivities_chatActivityConnection_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatActivity",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Patient",
                  "kind": "LinkedField",
                  "name": "patient",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "readByUser",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_patient",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_assignee",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "oid_groupAssignee",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "includeAssignee",
                      "variableName": "includeAssignee"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "ListItemChatActivity_EmbedChatActivity"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
(node as any).hash = 'd93ef09d029e710c36a42afb0c6afaab';
export default node;
